// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {SeqId} from './seq-id.js'

export class SeqMove {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): SeqMove {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsSeqMove(bb: flatbuffers.ByteBuffer, obj?: SeqMove): SeqMove {
    return (obj || new SeqMove()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsSeqMove(bb: flatbuffers.ByteBuffer, obj?: SeqMove): SeqMove {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new SeqMove()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  toId(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startSeqMove(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addToId(builder: flatbuffers.Builder, toIdOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, toIdOffset, 0)
  }

  static endSeqMove(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }

  static createSeqMove(builder: flatbuffers.Builder, toIdOffset: flatbuffers.Offset): flatbuffers.Offset {
    SeqMove.startSeqMove(builder)
    SeqMove.addToId(builder, toIdOffset)
    return SeqMove.endSeqMove(builder)
  }
}
